// extracted by mini-css-extract-plugin
export default {"refund":"RefundPolicy_refund__iJ2eI","refund__content":"RefundPolicy_refund__content__ynGB4"};